import type { RouteDriveSource } from './tripRouteEta';

/** i18n key under `trips.*` for a route_drive_source tag. */
export function routeDriveSourceI18nKey(
  source: RouteDriveSource | string | null | undefined
): 'routeDriveGoogle' | 'routeDriveStatic' | 'routeDriveStaticFallback' | null {
  if (!source || source === 'unavailable') return null;
  if (source === 'directions') return 'routeDriveGoogle';
  if (source === 'static_fallback') return 'routeDriveStaticFallback';
  if (source === 'static') return 'routeDriveStatic';
  return 'routeDriveStatic';
}

export function routeDriveSourceTagColor(
  source: RouteDriveSource | string | null | undefined
): 'blue' | 'orange' | 'default' {
  if (source === 'directions') return 'blue';
  if (source === 'static_fallback') return 'orange';
  return 'default';
}

/** Format meters as km with 1 decimal for UI. */
export function formatRouteDriveKm(meters: number | null | undefined): string | null {
  if (typeof meters !== 'number' || !Number.isFinite(meters) || meters < 0) return null;
  return (meters / 1000).toFixed(1);
}
